import { StoreReview, StoreRating } from '../types/review';
import { ApiErrorResponse } from '../types/auth';
import { createApiClient } from '../utils/axiosConfig';
import axios from 'axios';

const apiClient = createApiClient();

export type { StoreReview, StoreRating };

export const getStoreReviews = async (storeId: number): Promise<StoreReview[]> => {
  try {
    const response = await apiClient.get<StoreReview[]>(`/store/${storeId}/reviews`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const apiError = error.response.data as ApiErrorResponse;
      throw new Error(apiError.message || 'Failed to fetch store reviews');
    }
    console.error('Get store reviews error:', error);
    throw new Error('An unexpected error occurred while fetching store reviews.');
  }
};

export const getStoreRating = async (storeId: number): Promise<StoreRating> => {
  try {
    const response = await apiClient.get<StoreRating>(`/store/${storeId}/rating`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const apiError = error.response.data as ApiErrorResponse;
      throw new Error(apiError.message || 'Failed to fetch store rating');
    }
    console.error('Get store rating error:', error);
    throw new Error('An unexpected error occurred while fetching store rating.');
  }
};

